import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MDReactComponent from 'markdown-react-js';

import Carousel from '@/components/Carousel';
import MetaDetail from '@/components/atoms/MetaDetail';
import ButtonCTA from '@/components/atoms/ButtonCTA';
import BackBtn from '@/components/atoms/BackBtn';
import LazyLoadImage from '@/components/atoms/LazyLoadImage';
import Newsletter from '@/components/organisms/Newsletter';
import { fetchArticlesData } from '@/services/contentEvents/actions';
import getMetaScripts from './meta';
import Axios from 'axios';
import moment from 'moment';

import tracking from '@/utils/tracking';

import './Article.scss';

// markdown can't render table element, so we use code block in the CMS to store table
const handleIterate = function (Tag, props, children) {
	switch (Tag) {
		case 'pre':
			return <div {...props} dangerouslySetInnerHTML={{ __html: children[0].children[0] }} />;
	}
	return <Tag {...props}>{children}</Tag>;
};

class Article extends React.Component {
	constructor (props) {
		super(props);
		this.getArticle();
	}

	componentDidMount () {
		window.scrollTo(0, 0);
		tracking.pageView(this.props.location.pathname);
	}

	componentDidUpdate (prevProps) {
		const { pathname } = this.props.routeProps.location;

		if (prevProps.routeProps.location.pathname !== pathname) {
			window.scrollTo(0, 0);
			tracking.pageView(
				`/journal/${this.props.routeProps.match.params.eventId || ''}`
			);
		}
	}

	async getArticleItem (arts, slug) {
		let articleRef;

		for (let art of arts) {
			let match = false;
			for (let field of art.fields) {
				if (field.id === 'urlslug' && field.value === slug) {
					match = true;
					break;
				}
			}
			if (match) {
				for (let field of art.fields) {
					if (field.id === 'journalentry') {
						articleRef = field.value;
						await Axios.get(articleRef)
							.then((res) => {
								this.setState({ articleData: res.data.contents[0] });
								return res;
							});
					}
				}
			}
		}
	}

	async getArticle () {
		const path = window.location.pathname;
		let articleSlug = path.slice(path.lastIndexOf('/') + 1);

		if (!this.props.articlesData.length) {
			const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';
			await Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/All Journal Entries.json?v=${Math.random()}`)
				.then(response => response.data.contents)
				.then((arts) => { this.getArticleItem(arts, articleSlug); });
		}
		else {
			let article = this.props.articlesData.find(
				article => article.urlslug === articleSlug
			);
			await Axios.get(article.journalentry).then(response => {
				this.setState({ articleData: response.data.contents[0] });
			});
		}
	}

	renderCTA (article) {
		let ctaText;
		let ctaLink;
		// let ctaAction
		let genCtaText;
		let genCtaLink;
		// let genCtaAction

		for (let field of article.fields) {
			if (field.id === 'cta-book') {
				for (let ctaField of field.fields) {
					if (ctaField.id === 'ctatext') {
						ctaText = ctaField.value;
					}
					else if (ctaField.id === 'ctalink') {
						ctaLink = ctaField.value;
					}
					else if (ctaField.id === 'ctaaction') {
						// ctaAction = ctaField.value
					}
				}
			}
			else if (field.id === 'cta-general') {
				for (let genCtaField of field.fields) {
					if (genCtaField.id === 'cta-generaltext') {
						genCtaText = genCtaField.value;
					}
					else if (genCtaField.id === 'cta-generallink') {
						genCtaLink = genCtaField.value;
					}
					else if (genCtaField.id === 'cta-generalaction') {
						// genCtaAction = genCtaField.value
					}
				}
			}
		}

		// const { cta_general_text, cta_general_link } = article.cta_general

		return (
			<div className="Article__cta">
				{ctaText && ctaLink && <ButtonCTA href={ctaLink} label={ctaText} />}
				{genCtaText && genCtaLink && (
					<ButtonCTA
						href={genCtaLink}
						label={genCtaText}
						bordered
					/>
				)}
			</div>
		);
	}

	formatDate (date) {
		let formattedDate = moment(date, 'DD/MM/YYYY').format('dddd Do MMMM YYYY');
		return formattedDate;
	}

	render () {
		const { routeProps } = this.props;
		const article = this.state.articleData;

		if (!article) return null;

		let title;
		let bodyCopy;
		let bodyCopy2;
		let imageCollection;
		let articleKey;
		let heroData;
		let lgHero;
		let dfltHero;
		let heroSrcSet;
		let meta;
		let authName;
		let authRef;
		let pubDate;

		for (let field of article.fields) {
			if (field.id === 'title') {
				title = field.value;
				continue;
			}
			else if (field.id === 'urlslug') {
				articleKey = field.value;
				continue;
			}
			else if (field.id === 'heroimage') {
				for (let imgField of field.fields) {
					if (imgField.id === 'heroimagelarge_') {
						lgHero = imgField.imgURL;
					}
				}
				for (let imgField of field.fields) {
					if (imgField.id === 'heroimagedefault') {
						dfltHero = imgField.imgURL;
						break;
					}
				}

				heroData = lgHero || dfltHero;
				heroSrcSet = lgHero && dfltHero ? `${dfltHero} 750w, ${lgHero} 1984w` : '';
				continue;
			}
			else if (field.id === 'metainformation') {
				meta = field.fields;
				continue;
			}
			else if (field.id === 'authorinfo') {
				for (let authField of field.fields) {
					if (authField.id === 'name') {
						authName = authField.value;
					}
					else if (authField.id === 'slug') {
						authRef = authField.value;
					}
				}
				continue;
			}
			else if (field.id === 'datepublished') {
				pubDate = this.formatDate(field.value);
				continue;
			}
			else if (field.id === 'bodycopy') {
				bodyCopy = field.value;
				continue;
			}
			else if (field.id === 'bodycopy2') {
				bodyCopy2 = field.value;
				continue;
			}
			else if (field.id === 'imagecollection' && field.fields.length) {
				imageCollection = field.fields.filter((imgField) => imgField.imgURL !== '');
				continue;
			}
		}

		// console.log('meta: ', meta)

		return (
			<article className="Article">
				<MetaDetail script={getMetaScripts(article)} data={meta} />
				<BackBtn
					clickHandler={() => {
						tracking.event('customEvent', {
							eventCategory: 'Article Back',
							eventAction: 'click',
							eventLabel: routeProps.location.pathname
						});
						routeProps.history.goBack();
					}}
				/>

				<div className="Article__hero">
					<img
						className="Article__hero-image"
						src={heroData}
						srcSet={heroSrcSet}
						alt={title}
					/>
				</div>

				<div className="Article__wrapper">
					<header className="Article__content">
						<h1 className="Article__content-heading">
							{title}
						</h1>
						{pubDate && <h2 className="Article__content-pubdate">{pubDate}</h2>}
						{authName && authRef &&
							<h3 className="Article__content-author">
							  <a href={`/authors/${authRef}`}>BY {authName}</a>
							</h3> ||
							authName &&
							<h3 className="Article__content-author">BY {authName}</h3>
						}
						<div className="Article__copy">
							<MDReactComponent text={bodyCopy} />
						</div>
					</header>

					{imageCollection.length ? (
						<div
							className="Article__carousel-wrapper"
							key={`article-carousel_${articleKey}`}
							ref={el => {
								if (!this.galleryRef && el) {
									this.galleryRef = el;
								}
							}}
						>
							<Carousel
								desktopEnabled
								className="Article__carousel"
								arrows
								settings={{ responsive: { 578: { items: 2 } } }}
								slidesToShow={2}
							>
								{imageCollection.map((item, index) => (
									<LazyLoadImage
										key={`article-carousel-item_${index}`}
										className="Article__carousel-image"
										src={item.imgURL}
										alt={item.alternateText}
										lazyCallback={() => { }}
									/>
								))}
							</Carousel>
						</div>
					) : (
						''
					)}

					{bodyCopy2 !== '' ? (
						<div className="Article__content">
							<div className="Article__copy">
								<MDReactComponent text={bodyCopy2} onIterate={handleIterate} />
							</div>
						</div>
					) : (
						''
					)}

					<div className="Article__content">{this.renderCTA(article)}</div>

					<Newsletter
						formData={this.props.componentData.signUpForm}
						fetchData={this.props.fetchData}
						routeProps={this.props.routeProps}
					/>
				</div>
			</article>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	articlesData: state.pageContent.articlesData
});

export default withRouter(
	connect(
		mapStateToProps,
		{ fetchArticlesData }
	)(Article)
);



// WEBPACK FOOTER //
// ./src/components/organisms/Article/index.js